import React, { useState } from 'react';
import { View, Alert } from 'react-native';
import { Button, Card } from '@ant-design/react-native';
import notifee from '@notifee/react-native';
import { handleNotificationNavigation } from 'app/services/NavigationService';
import { api } from 'app/api/client';

export const NotificationTester: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);

  const testRemeasurementNotification = async () => {
    try {
      await notifee.displayNotification({
        title: 'Test Remeasurement Alert',
        body: 'This is a test notification for remeasurement flow',
        data: {
          type: 'remeasurement',
          measurementId: 'test-measurement-123',
          vitalParameterName: 'blood_pressure'
        },
        android: {
          channelId: 'remeasurement_alerts',
          smallIcon: 'ic_notification',
          pressAction: {
            id: 'open_remeasurement',
          },
        },
      });
      Alert.alert('Success', 'Test remeasurement notification sent!');
    } catch (error) {
      Alert.alert('Error', 'Failed to send notification');
    }
  };

  const testChatNotification = async () => {
    try {
      await notifee.displayNotification({
        title: 'Test Chat Message',
        body: 'This is a test chat notification',
        data: {
          type: 'chat',
          channelUrl: 'test-channel-url-123'
        },
        android: {
          channelId: 'sendbird_messages',
          smallIcon: 'ic_notification',
          pressAction: {
            id: 'open_chat',
          },
        },
      });
      Alert.alert('Success', 'Test chat notification sent!');
    } catch (error) {
      Alert.alert('Error', 'Failed to send notification');
    }
  };

  const triggerSendbirdTest = async () => {
    try {
      setIsLoading(true);
      await api.post('/rpm/api/v1/notification/test-sendbird');
      Alert.alert('Success', 'Sendbird test notification triggered!');
    } catch (error: any) {
      console.error(error);
      const errorMessage = error?.response?.data?.message || error.message || 'Failed to trigger notification';
      Alert.alert('Error', errorMessage);
    } finally {
      setIsLoading(false);
    }
  };


  return (
    <Card style={{ margin: 16 }}>
      <Card.Header
        title="Notification Test Panel"
        style={{ backgroundColor: '#f5f5f5' }}
      />
      <Card.Body>
        <View style={{ gap: 12 }}>
          <Button
            type="primary"
            onPress={testRemeasurementNotification}
          >
            Test Remeasurement Notification
          </Button>

          <Button
            type="primary"
            onPress={testChatNotification}
          >
            Test Chat Notification
          </Button>

          <Button
            type="warning"
            onPress={triggerSendbirdTest}
            loading={isLoading}
          >
            Trigger Backend Sendbird Push
          </Button>

        </View>
      </Card.Body>
    </Card>
  );
};
